// #region Fund
export interface Fund {
	name: string;
	title: string;
	code: string;
	logo?: string;
	lastSync?: Date;
	totalInvestor?: number;
	totalAsset?: number;
	redemptionNav?: number;
	issuanceNav?: number;
	issuancestaticwage?: number;
	redemtionstaticwage?: number;
	profitInfo?: profitInfo;
	progressPercents?: ProgressPercents[];
	limitDay?: LimitDay;
	penalties?: any[];
	isTemporary?: boolean;
	website?: string;
	hasTransaction?: boolean;
	description: string;
	details: string[];
	agreementData: AgreementData[];
	nextNavEstimate?: number;
}

export interface LimitDay {
	maxIssuance: number;
	maxRedemption: number;
	minIssuance: number;
	minRedemption: number;
}

export interface penalties {
	start: number;
	end: number;
	value: number;
}

export interface ProgressPercents {
	name: string;
	value: number;
	days?: number;
}

export interface profitInfo {
	payProfitDateDesc: string;
	calculateProfitDateDesc: string;
}

export interface AgreementData {
	id: string;
	subject: string;
	title: string;
	description: string;
}

// #endregion
// #region Asset
export interface Asset {
	name?: string;
	title?: string;
	fundCode: string;
	count: number;
	nav: number;
	amount?: number;
	lastSync?: Date | string;
	logo?: string;
	progressPercents?: ProgressPercents[];
	employeeShareAmount: number;
	employerShareAmount: number;
	personalShareAmount: number;
}

// #endregion
// #region Transaction

export interface IssuanceTransaction {
	fundCode: string;
	fundResult: FundResult;
	issueFinancialResult: IssueFinancialResult;
	issueRemain: IssueRemain;
	request: Request;
	fundName?: string;
	logo?: string;
	showDetails?: boolean;
}

export interface RedemptionTransaction {
	fundCode: string;
	result: RedemptionResult;
	request: RedemptionRequest;

	fundName?: string;
	logo?: string;
	showDetails?: boolean;
}

interface Request {
	status: FundTransactionStatus;
	amount: number;
	requestDate: Date | string;
	requestId: string;
	stateClass?: string;
	bankName?: string;
	iban?: string;
}

interface RedemptionRequest {
	status: FundTransactionStatus;
	count: number;
	amount: number;
	requestDate: Date | string;
	requestId: string;
	stateClass?: string;
	bankName?: string;
	iban?: string;
}

interface IssueFinancialResult {
	status: FundTransactionStatus;
	approveDate?: Date | string;
	failedDate?: Date | string;
	failedReason: string;
	stateClass?: string;
}

interface RedemptionResult {
	status: FundTransactionStatus;
	approvedAmount: number;
	approvedCount: number;
	navAmount: number;
	confirmtDate?: Date | string;
	stateClass?: string;
	pensionFundType: PensionFundType;
}

interface FundResult {
	status: FundTransactionStatus;
	requestId: string | any;
	approvedAmount: number;
	approvedCount: number;
	approvedDate?: Date | string;
	stateClass?: string;
	approvedNav?: number;
	pensionFundType: PensionFundType;
}

interface IssueRemain {
	status?: FundTransactionStatus;
	remainAmount: number;
	stateClass?: string;
}

// #endregion
export interface navHistory {
	fundCode: string;
	issuanceNav: number;
	redemptionNav: number;
	navDate: Date;
}

export interface navHistoryChart {
	d: string;
	v: number;
}

export interface createIssuanceRequest {
	amount: number;
	fundCode: string;
	effectedDate: Date;
}

export interface redemptionRequest {
	fundCode: string;
	count: number;
	iban: string;
}

export interface cancelRedemptionRequest {
	fundCode: string;
	requestId: number;
}

export interface issuanceResponse {
	requestId: string;
}

export interface agreementRequest {
	fundCode: string;
	agreementType: FundAgreementType;
	agreementId?: string;
}

export type navHistoryFilter = {
	fundCode: string;
	fromDate: string;
	toDate: string;
};
export type FundsData = {
	allFund: Fund[];
	userFund: Asset[];
};
export type FundConfirm = {
	fund: Fund;
	fundSide: FundSide;
	value: number;
	isNoneEtfSubscription: boolean;
	iban?: string;
};

export enum FundAgreementType {
	Main,
	SellPenalty,
	Custom
}

export enum FundSide {
	Buy = 0,
	Sell = 1,
	All
}

export const DestinationAccount = {
	accountNumber: '',
	bankTitle: 'اضافه شدن به قدرت خرید',
	iban: null,
	constIban: '-99999'
};

export enum FundTransactionStatus {
	NotStarted = 0,
	InProgress = 1,
	Done = 2,
	Failed = 3,
	Canceled = 4
}

export interface fundLoadOptions {
	page: number;
	size: number;
	// type: FundSide
}

export enum FundPopupType {
	None = 1,
	Buy = 2,
	Sell = 3,
	Increase = 4,
	Confirm = 5
}
export interface FundPopupModel {
	popupType?: FundPopupType;
	value?: string | number | unknown;
}

export enum FundPageName {
	Fund = 'Fund',
	FundDetail = 'FundDetail',
	Transaction = 'Transaction',
	NoneEtf = 'NoneEtf'
}
export enum PensionFundType {
	Employer = 1,
	Employee = 2,
	Personal = 3
}

export interface FundPages {
	name: FundPageName;
	activeFund: Partial<Fund>;
}

export type CatchErrorOption = {
	hasErrorNotify: boolean;
};

export type BankInfo = {
	bankTitle: string;
	iban: string;
	accountNumber: string;
	constIban?: string;
};
